import React from 'react';
import { motion } from 'framer-motion';
import { LightBulbIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';
import print1 from "../../assets/landing/print1.png";
import mascot from "../../assets/aboutus_mascot.PNG";

const founders = [
  {
    name: 'Surafel Kindu',
    role: 'Co-Founder & CEO',
    image: print1,
    socials: {
      linkedin: 'https://linkedin.com/in/surafel',
      twitter: 'https://twitter.com/surafel',
      instagram: 'https://instagram.com/surafel',
    },
  },
  {
    name: 'Bethelhem Tarekegn',
    role: 'Co-Founder & CTO',
    image: print1,
    socials: {
      linkedin: 'https://linkedin.com/in/bethelhem',
      twitter: 'https://twitter.com/bethelhem',
      instagram: 'https://instagram.com/bethelhem',
    },
  },
  {
    name: 'Dawit Minuyelet',
    role: 'Co-Founder & Creative Director',
    image: print1,
    socials: {
      linkedin: 'https://linkedin.com/in/dawit',
      twitter: 'https://twitter.com/dawit',
      instagram: 'https://instagram.com/dawit',
    },
  },
];

const partners = [print1, print1, print1, print1];

const stats = [
  { value: '3', label: 'Co-founders' },
  { value: '4+', label: 'Service lines' },
  { value: '1', label: 'Focused team' },
];

const values = [
  {
    icon: LightBulbIcon,
    title: 'Mission',
    description: 'We help ambitious teams turn ideas into polished, reliable digital products through design, engineering, and applied AI.',
  },
  {
    icon: RocketLaunchIcon,
    title: 'Vision',
    description: 'A world where every growing business has access to studio-quality software, not just companies with enterprise budgets.',
  },
];

const socialIcons = {
  linkedin: (props) => (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  ),
  instagram: (props) => (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
        clipRule="evenodd"
      />
    </svg>
  ),
  twitter: (props) => (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
    </svg>
  ),
};

export default function AboutUs() {
  return (
    <div className="min-h-screen w-full bg-white">
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-28 pb-20 sm:pt-36 sm:pb-28">
        <div className="mx-auto max-w-6xl px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-8 sm:p-12"
          >
            <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-secondary/25 blur-3xl" />

            <div className="relative flex flex-col items-center gap-8 text-center lg:flex-row lg:items-center lg:justify-between lg:gap-12 lg:text-left">
              <div>
                <div className="mb-4 flex items-center justify-center gap-2 lg:justify-start">
                  <span className="h-2 w-2 flex-none rounded-sm bg-secondary" aria-hidden="true" />
                  <p className="text-xs font-semibold uppercase tracking-[0.3em] text-secondary-dark">Our story</p>
                </div>
                <h1 className="max-w-xl text-pretty text-4xl font-semibold tracking-tight text-gray-950 sm:text-5xl">
                  Building digital products with purpose.
                </h1>
                <p className="mt-6 max-w-md text-lg leading-8 text-gray-600">
                  Afroawi Technologies started as a small team obsessed with getting the details right. Today we help
                  ambitious businesses design, build, and ship software that people actually enjoy using.
                </p>

                <div className="mt-10 grid max-w-md grid-cols-3 gap-4">
                  {stats.map((stat) => (
                    <div key={stat.label} className="rounded-lg border border-gray-200 p-4">
                      <p className="text-2xl font-semibold text-gray-950">{stat.value}</p>
                      <p className="mt-1 text-xs text-gray-500">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>

              <img
                src={mascot}
                alt="Afroawi mascot waving"
                className="h-56 w-auto flex-none object-contain sm:h-64"
              />
            </div>
          </motion.div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="border-t border-gray-100 py-20 sm:py-24">
        <div className="mx-auto max-w-5xl px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            {values.map((item, index) => {
              const Icon = item.icon;

              return (
                <motion.div
                  key={item.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="rounded-lg border border-gray-200 p-8"
                >
                  <div className="flex h-11 w-11 items-center justify-center rounded-full border border-secondary/40 text-secondary-dark">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </div>
                  <h2 className="mt-5 text-xl font-semibold text-gray-950">{item.title}</h2>
                  <p className="mt-2 text-sm leading-6 text-gray-600">{item.description}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Founders Section */}
      <section className="border-t border-gray-100 py-20 sm:py-24">
        <div className="mx-auto max-w-6xl px-6 lg:px-8">
          <div className="mb-12 flex items-center gap-2">
            <span className="h-2 w-2 flex-none rounded-sm bg-secondary" aria-hidden="true" />
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-secondary-dark">Meet the founders</p>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {founders.map((founder, index) => (
              <motion.div
                key={founder.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="rounded-lg border border-gray-200 p-8 text-center transition duration-200 hover:border-secondary/60"
              >
                <div className="relative mx-auto mb-6 h-32 w-32">
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className="h-full w-full rounded-full border-4 border-secondary object-cover"
                  />
                </div>
                <h3 className="text-lg font-semibold text-gray-950">{founder.name}</h3>
                <p className="mb-6 mt-1 text-sm font-medium text-primary">{founder.role}</p>

                <div className="flex justify-center gap-4">
                  {founder.socials.linkedin && (
                    <a href={founder.socials.linkedin} target="_blank" rel="noopener noreferrer" className="text-gray-400 transition-colors hover:text-primary">
                      {socialIcons.linkedin({ className: "h-5 w-5" })}
                    </a>
                  )}
                  {founder.socials.twitter && (
                    <a href={founder.socials.twitter} target="_blank" rel="noopener noreferrer" className="text-gray-400 transition-colors hover:text-primary">
                      {socialIcons.twitter({ className: "h-5 w-5" })}
                    </a>
                  )}
                  {founder.socials.instagram && (
                    <a href={founder.socials.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-400 transition-colors hover:text-primary">
                      {socialIcons.instagram({ className: "h-5 w-5" })}
                    </a>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="border-t border-gray-100 py-16 sm:py-20">
        <div className="mx-auto max-w-5xl px-6 lg:px-8">
          <div className="mb-10 flex items-center gap-2">
            <span className="h-2 w-2 flex-none rounded-sm bg-secondary" aria-hidden="true" />
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-secondary-dark">Our partners</p>
          </div>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
            {partners.map((logo, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                className="flex h-24 items-center justify-center rounded-lg border border-gray-200 p-4 transition duration-200 hover:border-secondary/60"
              >
                <img
                  src={logo}
                  alt={`Partner ${index + 1}`}
                  className="h-full w-full object-contain grayscale transition-all duration-300 hover:grayscale-0"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
